import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import Header from "common/js/header/header";
import Loader from "common/components/Loader";

import { getStaffDtlsListSvc } from "./staffDtlsSvc";
import StaffDtlsTbl from "./staffDtlsTbl";
import EditStaffSlider from "./editStaffSlider";
import StaffSubjectSlider from "./staffSubjectSlider";

function StaffDtls() {
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [flgEditSliderVisible, setFlgEditSliderVisible] = useState(false);
    const [flgStaffSubjectSliderVisible, setFlgStaffSubjectSliderVisible] = useState(false);
    const [tableKey, setTableKey] = useState(0);

    const [staffId, setStaffId] = useState(0);
    const [staffObj, setStaffObj] = useState({});
    const [lstStaff, setLstStaff] = useState([]);

    useEffect(() => {
        // console.log("StaffDtls called ");
        getStaffDtlsList();
    }, [tableKey]);




    const getStaffDtlsList = () => {
        // console.log("getStaffDtlsList called");
        setLoader("block");
        setOpacity(0.5);
        getStaffDtlsListSvc(staffDtlsListResponse);
    }


    const staffDtlsListResponse = (data) => {
        // console.log("staffDtlsListResponse called, data", data);
        if (data.status === "Success") {
            // console.log("inside staffDtlsListResponse, data.lstStaffDtls", data.lstStaffDtls);
            setLstStaff(data.lstStaffDtls);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }



    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    const handleSelectStaff = async (pStaff) => {
        // console.log("handleSelectStaff called, pStaff", pStaff);
        if (!flgEditSliderVisible && !flgStaffSubjectSliderVisible) {
            setStaffId(pStaff.staffId);
        } else {
            await setStaffObj(pStaff);
            setStaffId(pStaff.staffId);
        }
    }

    const editStaff = async (pStaff) => {
        // console.log("editStaff called, pStaff", pStaff);
        await setStaffObj(pStaff);
        openEditSlider();
    }
    const selectStaffClassSubject = async (pStaff) => {
        // console.log("selectStaffClassSubject called, pStaff", pStaff);
        // console.log("editStaff called, pStaff", pStaff);
        await setStaffId(pStaff.staffId);
        await setStaffObj(pStaff);
        openStaffSubjectSlider();
    }

    const openEditSlider = () => {
        setFlgStaffSubjectSliderVisible(false);
        setFlgEditSliderVisible(true);
    }

    const closeEditSlider = () => {
        setFlgEditSliderVisible(false);
    }

    const openStaffSubjectSlider = () => {
        setFlgEditSliderVisible(false);
        setFlgStaffSubjectSliderVisible(true);
    }

    const closeStaffSubjectSlider = () => {
        setFlgStaffSubjectSliderVisible(false);
    }

    return (
        <div >
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: (loader === "none") ? 'pointer' : 'none',
                    pointerEvents: (loader === "none") ? 'auto' : 'none',
                    opacity: opacity
                }}>
                <div className="col-md-8 col-sm-8 col-xs-10 col-centered padding-remove" style={{ marginTop: "35px" }}>
                    <StaffDtlsTbl
                        key={lstStaff}
                        staffId={staffId}
                        lstStaff={lstStaff}
                        handleSelectStaff={handleSelectStaff}
                        editStaff={editStaff}
                        selectStaffClassSubject={selectStaffClassSubject}

                    />
                </div>
            </div>
            {
                flgEditSliderVisible ?
                    <div className="slider1-60">
                        <EditStaffSlider
                            staffObj={staffObj}
                            closeSlider={closeEditSlider}
                        />
                    </div>
                    : null
            }
            {
                flgStaffSubjectSliderVisible ?
                    <div className="slider1-70">
                        <StaffSubjectSlider
                            key={staffId}
                            userId={staffId}
                            closeSlider={closeStaffSubjectSlider}
                        />
                    </div>
                    : null
            }
        </div>
    )
}

export default StaffDtls